import { useFonts } from 'expo-font'
import { Slot } from 'expo-router'
import type { ReactNode } from 'react'

export const AnimatedSplashScreen = ({ children }: { children: ReactNode }) => {
	const [fontsLoaded, fontError] = useFonts({
		'MaisonNeue-Bold': require('#/assets/fonts/MaisonNeue-Bold.otf'),
		'MaisonNeue-Demi': require('#/assets/fonts/MaisonNeue-Demi.otf'),
		'MaisonNeue-Light': require('#/assets/fonts/MaisonNeue-Light.otf'),
		'MaisonNeue-Medium': require('#/assets/fonts/MaisonNeue-Medium.otf'),
	})

	if (!fontsLoaded && !fontError) {
		return <Slot />
	}

	return children
}
